import angular from 'angular';

const componentOptions = {
    bindings: {
        text: '=',
        icon: '=',
        type: '='
    },
    controllerAs: 'ibBoxWarningCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-box-warning.html';
    }]
};


const componentInfo = {
    module: 'ib-box-warning-module',
    selector: 'ibBoxWarning',
    inject: ['$filter', '$rootScope'],
    required: ['']
};

export class ibBoxWarning implements ng.IController {
    public text;
    public icon;
    public type;
    public ampliado: boolean = true;
    public isOpen: boolean = true;
    public readText: string = this.$filter('translate')('READ_MORE');
    public readMore: string = this.$filter('translate')('READ_MORE');
    public readLess: string = this.$filter('translate')('READ_LESS');

    constructor (
        private $filter: ng.IFilterService,
        private $rootScope: CommonsRootScope) {}

    activate = (): void => {
    };

    openClose = () =>{
        this.ampliado = !this.ampliado;
        if(this.ampliado) {
            this.readText = this.readMore;
        } else {
            this.readText = this.readLess;
        }
    };

    close = ():void => {
        this.$rootScope.$broadcast('closeReductedMovilityBanner');
        this.isOpen = !this.isOpen;
    };

}


try {
    const mod = angular.module(componentInfo.module);
    ibBoxWarning.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibBoxWarning })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibBoxWarning.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibBoxWarning })
    );
}